import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';

import { ThemeService } from '../../core/theme.service';
import { TranslatePipe } from '../../core/translate.pipe';

@Component({
  selector: 'app-theme',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  template: `
    <section class="page-header">
      <div>
        <h1>{{ 'theme.title' | t }}</h1>
        <p>{{ 'theme.description' | t }}</p>
      </div>
    </section>

    <section class="theme-grid">
      <article
        class="theme-card"
        *ngFor="let theme of themeService.themes"
        [class.active]="themeService.isActive(theme.key)"
        [style.--theme-preview-bg]="theme.preview.bg"
        [style.--theme-preview-panel]="theme.preview.panel"
        [style.--theme-preview-line]="theme.preview.line"
        [style.--theme-preview-primary]="theme.preview.primary"
        [style.--theme-preview-accent]="theme.preview.accent"
        [style.--theme-preview-sidebar]="theme.preview.sidebar"
        [style.--theme-preview-text]="theme.preview.text">
        <div class="theme-card-head">
          <div>
            <h2>{{ theme.name | t }}</h2>
            <p>{{ theme.description | t }}</p>
          </div>
          <span class="status" *ngIf="themeService.isActive(theme.key)">{{ 'common.active' | t }}</span>
        </div>

        <div class="theme-swatches" aria-hidden="true">
          <span *ngFor="let color of theme.colors" [style.background]="color"></span>
        </div>

        <div class="theme-preview">
          <div class="theme-preview-sidebar"></div>
          <div class="theme-preview-content">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>

        <button
          type="button"
          class="icon-button-text"
          [class.secondary]="themeService.isActive(theme.key)"
          (click)="themeService.applyTheme(theme.key)">
          <span class="button-icon" aria-hidden="true">✓</span>
          {{ themeService.isActive(theme.key) ? ('common.selected' | t) : ('common.applyTheme' | t) }}
        </button>
      </article>
    </section>
  `
})
export class ThemeComponent {
  readonly themeService = inject(ThemeService);
}
